import BuyerLobby from "./components/lobby/buyer-lobby";

function LandingPageBuyer() {
  return (
    <div
      className="flex flex-col min-h-screen"
      style={{ background: "#f8fafa !important", paddingTop: 0 }}
    >
      <BuyerLobby />
    </div>
  );
}

export default LandingPageBuyer;
